'use client';

import { useTranslations } from '@fshr/context/i18n-context';
import { getConfig } from '@fshr/shared-react';
import Link from '../../link';
import { IconWarning } from '../../icon';
import { useEffect, useRef } from 'react';

interface Props {
	accomPath: string;
}

export default function NoHotelProductsWarning({ accomPath }: Props) {
	const t = useTranslations();
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		ref?.current?.scrollIntoView({
			block: 'end',
			behavior: 'smooth',
		});
	}, []);

	return (
		<div
			className="spacing-card-padding-xs flex flex-row justify-start items-start gap-100 bg-error-container-subtle rounded-[5px]"
			data-cy="NoHotelProductsWarning"
			ref={ref}
		>
			<div className="">
				<IconWarning />
			</div>
			<div className="flex flex-col justify-start gap-100">
				<span className="text-caption text-left text-warning-text text-[14px]">
					{t('To checkout, add a room to your cart')}
				</span>
				<div>
					<Link href={accomPath} intent="filled">
						{t('Check Rates')}
					</Link>
				</div>
			</div>
		</div>
	);
}
